// footer.component.ts
import {Component, computed, inject} from '@angular/core';
import {RouterLink} from '@angular/router';
import {ExternalLinkDirective} from "../../directives/external-link.directive";
import {IndexIoService} from '../../services/index-io.service';
import {DarkModeService} from '../../services/dark-mode.service';

@Component({
  selector: 'bnpp-indx-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
    imports: [RouterLink, ExternalLinkDirective],
  standalone: true,
})
export class FooterComponent{
  private indexInfoService = inject(IndexIoService);
  public deployUrlHost = this.indexInfoService.getDeployUrlHost();
  private darkModeService = inject(DarkModeService);
  protected logoUrl = computed(() => {
    const isDarkMode = this.darkModeService.isDarkMode();
    return isDarkMode ? `${this.deployUrlHost}/assets/LogoBNPParibas_Large.jpg` : `${this.deployUrlHost}/assets/logo-bnp.png`
  });
  footerLinks = [
    { label: 'Privacy Policy', link: '/privacy-policy' },
    { label: 'Terms of Service', link: '/terms-of-service' },
    { label: 'Contact Us', link: '/contact-us' },
  ];

  get currentYear(): number {
    return new Date().getFullYear();
  }
}
